import React, { useMemo } from 'react';
import BreakdownRingChart from '../../../../../shared/designSystem/components/BreakdownRingChart';

// SegmentsRingChart — thin adapter for the shared BreakdownRingChart.
//
// Two schema differences vs Creatives/Publishers that we normalize here:
//   - Segments use `ais` for ad impressions; BreakdownRingChart expects
//     `impressions`. Map one-to-one.
//   - Segments use `ctr` already in 0–100 form; BreakdownRingChart expects
//     `percentctr` in 0–1 form for consistent tooltip math. Divide by 100.
//   - Segments' dimension prop uses 'ais' / 'ctr' / 'clicks'; the primitive
//     uses 'impressions' / 'CTR' / 'clicks'. Translate via DIMENSION_MAP.

const DIMENSION_MAP = {
  ais: 'impressions',
  ctr: 'CTR',
  clicks: 'clicks',
};

const SegmentsRingChart = ({ data, height, selectedSegmentsDimension }) => {
  const normalized = useMemo(
    () =>
      (data || []).map((d) => ({
        ...d,
        impressions: d.ais,
        percentctr: (d.ctr || 0) / 100,
      })),
    [data]
  );

  return (
    <BreakdownRingChart
      data={normalized}
      dimension={DIMENSION_MAP[selectedSegmentsDimension] || 'impressions'}
      height={height}
    />
  );
};

export default SegmentsRingChart;
